export const LangEn = {
    name:'en',
    data:{
        "modalExp":{
            "name":"kd,mkdmdké"
        },
        "name":'Ceci est un test',
        "mission":{
            "tasks_title":"Tasks of the ",
            "tasks_title_elided":"Tasks of the "
        },
        map : new Map()
    }
}